// extracted by mini-css-extract-plugin
export default {"container":"Header_container__g0tuP","navBtn":"Header_navBtn__35vMu","extraSpace":"Header_extraSpace__9rF5-","backBtn":"Header_backBtn__XF-Lm"};